import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { useForm } from '../../../hooks/useForm';
import { AttachmentsForm } from '../../../components/supplierForm/AttachmentsForm';
import { LegalInformationForm } from '../../../components/supplierForm/LegalInformationForm';
import { EconomicActivityForm } from '../../../components/supplierForm/EconomicActivityForm';
import { LocationForm } from '../../../components/supplierForm/LocationForm';
import { LegalRepresenForm } from '../../../components/supplierForm/LegalRepresenForm';
import { BankingInformationForm } from '../../../components/supplierForm/BankingInformationForm';
import { useNotification } from '../../../hooks/useNotification';
import { useDispatch } from 'react-redux';
import { addNewProveedor, editsupplier } from '../../../redux/actions/proveedor';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { FinancialInformationForm } from '../../../components/supplierForm/FinancialInformationForm.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetSupplierOfficeID, fetchSupplierById } from '../../../services/proveedor.service';
import LoadingOverlay from '../../../components/others/LoadingOverlay.js';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { useTranslation } from 'react-i18next';


export const LayoutProvider = () => {
    const { t } = useTranslation();
    const [sendNotification] = useNotification();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [{ userSession }] = useDataAuth();
    const location = useLocation();
    const { config } = location.state || {};
    const provider = {
        // LegalInformation
        type_identification: '',
        identification: config?.identification || '',
        identification_digit: '',
        business_name: '',
        // email: '',
        society_type: '',
        company_type: '',
        supplier_tax_scheme: '',
        supplier_tax_level_code: [],
        // EconomicActivity
        type_ciiu: '',
        code_ciiu: '',
        description_ciiu: '',
        // location
        location: [],
        // LegalRepresen
        reprecentant_type: '',
        reprecentant_id_type: '',
        reprecentant_id: '',
        reprecentant_name: '',
        // bankingInfomation
        type_account: '',
        number_account: '',
        banking_company: '',
        banking_office: '',
        // financialInformation
        total_assets: 0,
        total_liabilities: 0,
        patrimony: 0,
        monthly_income: 0,
        expenses: 0,
        other_income: 0,
        cutoff_date_information: '',
    };
    const [values, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(provider);

    const attachmentsRef = useRef();
    const legalInfoRef = useRef();
    const economicActivityRef = useRef();
    const locationRef = useRef();
    const legalRepRef = useRef();
    const bankingInfoRef = useRef();
    const fincancialInformationRef = useRef();

    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const fetchSupplierData = useCallback(async (id) => {
        setIsEdit(true);
        setLoading(true);
        try {
            const response_location = await fetSupplierOfficeID(userSession.token, id);
            const response = await fetchSupplierById(userSession.token, id);
            if (response.status === 200) {
                const dto = response.data[0];
                dto.id_supplier = id;
                dto.location = response_location.status === 200 ? response_location.data || [] : [];
                setAllInfo(dto);
            }
        } catch (error) {
            console.error("Error fetching supplier data:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (location.state && location.state.config) {
            const { config } = location.state;
            console.log('config.data ', config.data);
            if (config.data?.id) {
                fetchSupplierData(config.data?.id);
            }
        }
    }, [fetchSupplierData, location.state]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const isValidLegalInfo = legalInfoRef.current?.validateForm();
        const isValidEconomicActivity = economicActivityRef.current?.validateForm();
        const isValidLegalRep = legalRepRef.current?.validateForm();
        const isValidBankingInfo = bankingInfoRef.current?.validateForm();
        const isValidFinancialInformation = fincancialInformationRef.current?.validateForm();

        console.log(isValidLegalInfo, isValidEconomicActivity, isValidLegalRep, isValidBankingInfo, isValidFinancialInformation);

        const data = JSON.stringify(values);
        if (isValidLegalInfo && isValidEconomicActivity && isValidLegalRep && isValidBankingInfo && isValidFinancialInformation) {
            if (isEdit) {
                dispatch(editsupplier(data, userSession.token));
                sendNotification({
                    msg: t("messages.saveSuccess"),
                    variant: "success",
                });
                Cancel();
            } else {
                console.log("data ", data)
                dispatch(addNewProveedor(data, userSession.token));
                sendNotification({
                    msg: t("messages.saveSuccess"),
                    variant: "success",
                });
                Cancel();
            }
        }
        else
            sendNotification({
                msg: t("validation.requiredFieldsMissing"),
                variant: "error",
            });
    };

    const Cancel = () => navigate(-1);

    return (
        <Box sx={{ width: '90%', mx: 'auto' }}>
            <Typography variant="h4" gutterBottom>
                {t("suppliers.suppliersTitle")}
            </Typography>

            <Card sx={{ mb: 3 }}>
                <CardContent >
                    <AttachmentsForm
                        ref={attachmentsRef}
                        handleInputChange={handleInputChange}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <LegalInformationForm
                        ref={legalInfoRef}
                        dto={values}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <EconomicActivityForm
                        ref={economicActivityRef}
                        dto={values}
                        handleInputChange={handleInputChange}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <LocationForm
                        ref={locationRef}
                        dto={values}
                        isEdit={isEdit}
                        handleDirectInputChange={handleDirectInputChange}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <LegalRepresenForm
                        ref={legalRepRef}
                        dto={values}
                        handleInputChange={handleInputChange}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <BankingInformationForm
                        ref={bankingInfoRef}
                        dto={values}
                        handleInputChange={handleInputChange}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <FinancialInformationForm
                        ref={fincancialInformationRef}
                        dto={values}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                    />

                    <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                    <ActionButtons
                        onSubmit={Cancel}
                        onCancel={handleSubmit}
                    />
                </CardContent>
            </Card>
            <LoadingOverlay isOpen={loading} />
        </Box >
    );
};
